import DangerousInnerHTML from './DangerousInnerHTML';

export default DangerousInnerHTML;
